import React from "react";
import MyIcon from "./MyIcon";

export default function MyFilterSubheading({
  Icon,
  heading,
  subheading,
  iconWidth = 30,
}) {
  return (
    <div className="mb-3 d-flex align-items-center">
      <MyIcon Icon={Icon} width={iconWidth} />
      <div className="mx-3">
        <h5 className="m-0 fw-bold">{heading}</h5>
        <div className="small text-white">{subheading}</div>
      </div>
    </div>
  );
}
